import internetIcon from "../../../assets/img/web.svg";
import instagramIcon from "../../../assets/img/instagram.svg";
import telegramIcon from "../../../assets/img/telegram.svg";
import mailIcon from "../../../assets/img/email.svg";

function Footer(props) {
  return (
    <footer className="page-section section-footer">
      <b>زبانشناس بهترین روش برای یادگیری</b>
      <div  >
        <a href="https://zabanshenas.com" target="blank">
          <img src={internetIcon} alt="" />
        </a>

        <a href="https://www.instagram.com/zabanshenas_com" target="blank">
          <img src={instagramIcon} alt="" />
        </a>
        <a href="https://t.me/zabanshenas_com" target="blank">
          <img src={telegramIcon} alt="" />
        </a>
        <a href="mailto:info@zabanshenas.com" target="blank">
          <img src={mailIcon} alt="" />
        </a>
      </div>
      <span>
        در صورت عدم تمایل برای دریافت پیام ها میتوانید از
        <button
          onClick={props.showUnsubscribePage}
          type="button"
          className="btn btn-link pt-0 pb-0 ps-1 pe-1"
        >
          اینجا
        </button>
        لغو اشتراک کنید
      </span>
    </footer>
  );
}

export default Footer;
